export const maxRecordTimes = [
  {
    name: '30 seg',
    id: 30,
    maxCharacters: 100,
  },
  {
    name: '1 min',
    id: 60,
    maxCharacters: 200,
  },
  {
    name: '2 min',
    id: 120,
    maxCharacters: 400,
  },
  {
    name: '3 min',
    id: 180,
    maxCharacters: 600,
  },
  {
    name: '4 min',
    id: 240,
    maxCharacters: 800,
  },
  {
    name: '5 min',
    id: 300,
    maxCharacters: 1000,
  },
];
export const maxPreparationTimes = [
  {
    name: '5 seg',
    id: 5,
  },
  {
    name: '15 seg',
    id: 15,
  },
  {
    name: '30 seg',
    id: 30,
  },
  {
    name: '1 min',
    id: 60,
  },
];
export const maxAttemptsOptions = [
  {
    name: '0',
    id: 0,
  },
  {
    name: '1',
    id: 1,
  },
  {
    name: '2',
    id: 2,
  },
  {
    name: '3',
    id: 3,
  },
  {
    name: '4',
    id: 4,
  },
];

// TODO validate this
export const AIDifficultyId = '64f5e4f13b7d7759631e6f09';
export const videoAnswerDifficultyId = '658068f6a6e9a25ee9245f83';
export const textAnswerDifficultyId = '682e370985d8ac586c2da616';
export const weightOptions = [
  { id: 1, name: '1', weight: 1 },
  { id: 2, name: '2', weight: 2 },
  { id: 3, name: '3', weight: 3 },
  { id: 4, name: '4', weight: 4 },
  { id: 5, name: '5', weight: 5 },
  { id: 6, name: '6', weight: 6 },
  { id: 7, name: '7', weight: 7 },
  { id: 8, name: '8', weight: 8 },
  { id: 9, name: '9', weight: 9 },
  { id: 10, name: '10', weight: 10 },
];
